import { AnyAction, Dispatch, Middleware, MiddlewareAPI } from "redux";
import ActionTypes from "../../../constants/ActionTypes";
import { apiRequest } from "../api/actions";
import ApiUrls from "../../../constants/ApiUrls";
import MiddlewareEntities from "../../../constants/MiddlewareEntities";
import { setNotification } from "../notification/actions";
import { INotification } from "../notification/types";
import createId from "../../../utilites/createid";
import NotificationTypes from "../../../constants/NotificationTypes";
import { setLoader } from "../ui/actions";
import { setDebugInfo } from "./actions";

export const debugMiddleware: Middleware = (store: MiddlewareAPI) => (next: Dispatch) => (action: AnyAction) => {
  next(action);
  switch (action.type) {
  case ActionTypes.DEBUG.GET_DEBUG_INFO:
    next(apiRequest(
      null,
      'GET', `${ApiUrls.DEBUG}`,
      {
        logs: 'om,pc',
      },
      null,
      MiddlewareEntities.DEBUG,
      {}),
    );
    break;
  case `${MiddlewareEntities.DEBUG} ${ActionTypes.API_SUCCESS}` :
    next(setDebugInfo(action.payload.data));
    next(setLoader(false, MiddlewareEntities.DEBUG));
    break;
  case `${MiddlewareEntities.DEBUG} ${ActionTypes.API_ERROR}` :
    const errorNotification: INotification[] = [{
      id: parseInt(createId("")),
      type: NotificationTypes.types.ERROR,
      message: 'Greška u GET debug info',
      cssClass: NotificationTypes.cssClass.ALERT_DANGER
    }];
    next(setNotification(errorNotification, MiddlewareEntities.DEBUG));
    next(setLoader(false, MiddlewareEntities.DEBUG));
    break;
  }};
